import {basename, staticFileLinks } from "../../../constants"



// fix retrieved next & prev buttons
export function fixLinks(htmlString){
    const target = "href=\""
    const splitByTarget = htmlString.split(target).splice(1)
    splitByTarget.forEach(element => {
        let pid;
        const originalHref = element.split("\"").shift()
        

        // if contains number
        if(originalHref.match(/\d+/g) != null){
            const lastThreeChars = originalHref.substring(originalHref.length - 3)
            if(!isNaN(parseInt(lastThreeChars))){
                pid = parseInt(lastThreeChars)
            } else if(!isNaN(parseInt(lastThreeChars.substring(originalHref.length - 2)))){
                pid = parseInt(lastThreeChars.substring(originalHref.length - 2))
            } else {
                // error
            }
        }
        if(htmlString.includes(originalHref)){
            if(!originalHref.includes("_blank")){
                // check if not external link
                htmlString = htmlString.replace(originalHref, basename + "/lerneinheiten/page/" + pid)
            } 
        }      
    });
    return htmlString

}

export function processHtmlString(htmlString){
    if(typeof (htmlString) === "string"){
        htmlString = htmlString.replaceAll("###IMPRINT###", "")
        if(htmlString.includes("page?uid=")){
            console.log("+++++++++++++htmlString")
            
            // internal link
            if(htmlString.includes("btn-outline-white")){
                console.log(htmlString)
                htmlString = htmlString.replace("btn-outline-white", "btn-outline-white handMadeButtonSpecial ")
            }
            htmlString = fixLinks(htmlString)
        }
        const fileSearchToken = "file?uid="
        if(htmlString.includes(fileSearchToken)){
            console.log("htmlString")
            console.log(htmlString)
            // get file id
            const fileIdAsString = htmlString.split(fileSearchToken)[1].split('"')[0]
            if(fileIdAsString && typeof fileIdAsString !== "undefined"){
                const fileId = parseInt(fileIdAsString)
                const fileLink =  staticFileLinks[fileId]
                // get corresponding file link from constants.js and replace in htmlString
                if(fileLink && typeof fileLink !== "undefined"){
                    const originalLink = htmlString.split('href="')[1].split('"')[0]
                    if(originalLink && typeof originalLink !== "undefined"){
                        // replace and set as external link
                        htmlString = htmlString.replace('href="' + originalLink, 'target="_blank" href="' + fileLink)
                    }
                }
            }
        }
        return htmlString
        // classname cant be used in "dangerouslysethtml"
        // return htmlString.replaceAll('class', 'className')
    } else return "ERROR"
}

export function removeSpecialChars(string){
    return string.replace(/[^a-zA-Z0-9<>(</)äüöÄÜÖ*.!?„“, ]/g, '')   // keep "<, >, </, äüöÄÜÖ*" etc
}


export function adjustListTags(rawString){
    rawString = rawString.replaceAll('classMsoNoSpacing', '') 
    rawString = rawString.replaceAll('class="MsoNoSpacing"', '') 
    return rawString.replaceAll('<ul>', '<ul class="listWithBullets mt-3">') 
}


export function pruneTypo3AddedTags(rawString){
    rawString = rawString.replaceAll(";", "; ")
    rawString = rawString.replaceAll("&nbsp;", "")
    rawString = rawString.replaceAll("_br_", "<br>")
    // get rid of automatically added <p></p>
    return rawString.replaceAll('<p>', '').replaceAll('</p>', '')
}


export function cutButtons(bodytext){
    if(bodytext.contents && bodytext.contents?.length > 0){
        const lastElement = bodytext.contents[bodytext.contents.length - 1];
        if(lastElement?.CType === "text"){
            if(lastElement.content.includes(">Zurück") || lastElement.content.includes(">Zurück") || lastElement.content.includes(">Weiter") || lastElement.content.includes(">weiter")){
                return {
                    ...bodytext,
                    contents: bodytext.contents.slice(0,-1)
                }
            } else {
                return bodytext
            }
        } else {
            return bodytext
        }
    } else {
        return bodytext
    }
}

export function adjustButtons(bodytext){
    if(bodytext.contents && bodytext.contents?.length > 0){
        const lastElement = bodytext.contents[bodytext.contents.length - 1];
        if(lastElement?.CType === "text"){
            if(lastElement.content.includes(">Zurück") || lastElement.content.includes(">Zurück") || lastElement.content.includes(">Weiter") || lastElement.content.includes(">weiter")){
                // change class for apearance of buttons coming from typo3 input
                const originalClassText = lastElement.content.split('class="')[1].split('"')[0]     // = "align-right"
                lastElement.content = lastElement.content.replace(originalClassText, originalClassText + " handMadeButtonsWrapper ")
                return bodytext
            //  return without handset buttons    
            //    return {
            //        ...bodytext,
            //        contents: bodytext.contents.slice(0,-1)
            //    }
            } else {
                return bodytext
            }
        } else {
            return bodytext
        }
    } else {
        return bodytext
    }
}

export function containsButtons(bodytext){
    if(bodytext.contents && bodytext.contents?.length > 0){
        const lastElement = bodytext.contents[bodytext.contents.length - 1];
        if(lastElement?.CType === "text"){
            if(lastElement.content.includes(">Zurück") || lastElement.content.includes(">Zurück") || lastElement.content.includes(">Weiter") || lastElement.content.includes(">weiter")){
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    } else {
        return false
    }
}